"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const home_1 = require("../../../sections/home");
const Home = () => {
    return (0, jsx_runtime_1.jsx)(home_1.HomeMobile, {});
};
exports.Home = Home;
